import { GetTenantModel } from "@factory/model/query-model-tenant";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { tenantFormDefault } from "./form.default";
import { TenantFormSchema } from "./form.rule";

export const useFormDefaultTenant = () => {
  const { formatDate, formatDateForInput } = useDateTimeContext();

  const getDefault = (cachedValue: GetTenantModel | undefined) => {
    return !cachedValue
      ? tenantFormDefault
      : ({
          owner: cachedValue.owner,
          businessName: cachedValue.business_name,
          businessType: cachedValue.business_type,
          description: cachedValue.description,
          avatar: cachedValue.avatar,
          email: cachedValue.email,
          mobileNumber: cachedValue.mobile_number,
          phoneNumber: cachedValue.phone_number,
          website: cachedValue.website,
          membershipDate: formatDate(cachedValue.membership_date) as any,
          rewardsType: cachedValue.rewards_type,
          slug: cachedValue.slug,
          postRegistrationLink: cachedValue.post_registration_link,
          enablePublicBookingTimeSelection:
            cachedValue.enable_public_booking_time_selection,
          dailyBookingLimit: cachedValue.daily_booking_limit,
          bookingLimitMessage: cachedValue.booking_limit_message,
          showAppointmentDetails: cachedValue.show_appointment_details,
          showServicesInPublicBooking:
            cachedValue.show_services_in_public_booking,
          defaultDate: cachedValue.default_date
            ? formatDateForInput(cachedValue.default_date)
            : undefined,
        } as TenantFormSchema);
  };

  return {
    getDefault,
  };
};
